import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class StudentProfileHelper{


    async getStudentProfile() {
        try {
          const response = await ApiHelper.get(API_ENDPOINTS.STUDENTS.PROFILE);
          return response;
        } catch (error) {
          throw new Error(`Failed to fetch student profile: ${error.message}`);
        }
    }

    async updateStudentDOB(dob) {
        try {
          const response = await ApiHelper.put(API_ENDPOINTS.STUDENTS.UPDATE_DOB, { dob });
          return response;
        } catch (error) {
          throw new Error(`Failed to update date of birth: ${error.message}`);
        }
    }

}

export default new StudentProfileHelper();